if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');
        this.activeMedia = this.elements.viewer?.querySelector('.product__media-item.is-active') || null;

        // Lightweight thumbnail lookup only. Bunny itself handles the video player.
        this.initBunnyThumbnails();

        if (!this.elements.viewer || !this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          const button = mediaToSwitch.querySelector('button');

          if (!button) return;

          button.addEventListener('click', (event) => {
            this.onThumbnailClick(mediaToSwitch, event);
          });
        });

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }
      }

      getMediaSlides() {
        if (!this.elements.viewer) return [];

        return Array.from(
          this.elements.viewer.querySelectorAll('.product__media-item[data-media-id]')
        );
      }

      markActiveMedia(activeMedia) {
        if (!activeMedia) return;

        this.getMediaSlides().forEach((slide) => {
          slide.classList.toggle('is-active', slide === activeMedia);
        });

        this.activeMedia = activeMedia;
      }

      onSlideChanged(event) {
        const currentElement = event.detail.currentElement;

        if (!currentElement) return;

        this.markActiveMedia(currentElement);

        const thumbnail = this.elements.thumbnails?.querySelector(
          `[data-target="${currentElement.dataset.mediaId}"]`
        );

        this.setActiveThumbnail(thumbnail);
        this.playActiveMedia(currentElement);
      }

      onThumbnailClick(thumbnailItem, event) {
        event.preventDefault();

        const mediaId = thumbnailItem.dataset.target;
        this.setActiveMedia(mediaId, false);
      }

      setActiveMedia(mediaId, prepend, suppressPlayback = false) {
        if (!this.elements.viewer) return;

        const activeMedia =
          this.elements.viewer.querySelector(`.product__media-item[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('.product__media-item[data-media-id]');

        if (!activeMedia) return;

        this.markActiveMedia(activeMedia);

        if (prepend) {
          if (activeMedia.parentElement.firstElementChild !== activeMedia) {
            activeMedia.parentElement.prepend(activeMedia);
          }

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`
            );

            if (activeThumbnail && activeThumbnail.parentElement.firstElementChild !== activeThumbnail) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (this.elements.viewer.slider) {
            this.elements.viewer.resetPages();
          }
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }

          const activeMediaRect = activeMedia.getBoundingClientRect();

          if (activeMediaRect.top > -0.5) return;

          window.scrollTo({
            top: activeMediaRect.top + window.scrollY,
            behavior: 'smooth',
          });
        });

        if (!suppressPlayback) {
          this.playActiveMedia(activeMedia);
        }

        if (!this.elements.thumbnails) return;

        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );

        this.setActiveThumbnail(activeThumbnail);

        if (activeThumbnail) {
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails.querySelectorAll('button').forEach((element) => {
          element.removeAttribute('aria-current');
        });

        const button = thumbnail.querySelector('button');

        if (button) {
          button.setAttribute('aria-current', 'true');
        }

        if (
          this.elements.thumbnails.isSlideVisible &&
          this.elements.thumbnails.isSlideVisible(thumbnail, 10)
        ) {
          return;
        }

        const thumbnailList = this.elements.thumbnails.slider ||
          this.elements.thumbnails.querySelector('.thumbnail-list');

        thumbnailList?.scrollTo({
          left: Math.max(0, thumbnail.offsetLeft - 8),
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');

        if (!image || !this.elements.liveRegion) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', 'false');
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace('[index]', position);

          window.setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', 'true');
          }, 2000);
        };

        image.src = image.src;
      }

      playActiveMedia(activeItem) {
  if (!activeItem) return;

  this.activeMedia = activeItem;

  if (window.pauseAllMedia) {
    window.pauseAllMedia();
  }

  /* Bunny Stream */
  if (activeItem.dataset.bunnyMedia === 'true') {
    const iframe = activeItem.querySelector('.gk-bunny-video-iframe');

    if (!iframe) return;

    /*
      Reload only when Bunny media becomes active.
      autoplay=true + muted=true are already in the iframe URL.
      Reloading causes Bunny native autoplay to trigger.
    */
    const currentSrc = iframe.src;

    if (currentSrc) {
      iframe.src = 'about:blank';

      requestAnimationFrame(() => {
        if (this.activeMedia !== activeItem) return;
        iframe.src = currentSrc;
      });
    }

    return;
  }

  /* Normal Shopify media */
  const deferredMedia = activeItem.querySelector('.deferred-media');

  if (
    deferredMedia &&
    typeof deferredMedia.loadContent === 'function'
  ) {
    deferredMedia.loadContent(false);
  }
}

      initBunnyThumbnails() {
        const bunnySlides = this.querySelectorAll('[data-bunny-media="true"]');

        bunnySlides.forEach((slide) => {
          const bunnyUrl = slide.dataset.bunnyUrl;

          if (!bunnyUrl) return;

          this.getBunnyMetadata(bunnyUrl)
            .then((metadata) => {
              if (!metadata?.thumbnailUrl || !this.isConnected) return;
              this.applyBunnyThumbnail(bunnyUrl, metadata.thumbnailUrl);
            })
            .catch(() => {
              // Keep the lightweight Shopify image fallback if Bunny metadata is unavailable.
            });
        });
      }

      getBunnyMetadata(bunnyUrl) {
        window.gkBunnyMetadataCache = window.gkBunnyMetadataCache || new Map();

        if (window.gkBunnyMetadataCache.has(bunnyUrl)) {
          return window.gkBunnyMetadataCache.get(bunnyUrl);
        }

        const request = fetch(
          `https://video.bunnycdn.com/OEmbed?url=${encodeURIComponent(bunnyUrl)}`,
          {
            method: 'GET',
            mode: 'cors',
            credentials: 'omit',
            headers: { Accept: 'application/json' },
          }
        ).then((response) => {
          if (!response.ok) {
            throw new Error(`Bunny thumbnail request failed with ${response.status}`);
          }

          return response.json();
        }).then((data) => ({
          thumbnailUrl: data.thumbnail_url || data.thumbnailUrl || null,
        }));

        window.gkBunnyMetadataCache.set(bunnyUrl, request);
        return request;
      }

      applyBunnyThumbnail(bunnyUrl, thumbnailUrl) {
        let safeThumbnailUrl;

        try {
          safeThumbnailUrl = new URL(thumbnailUrl, 'https://video.bunnycdn.com').toString();
        } catch (_error) {
          return;
        }

        const preloadImage = new Image();

        preloadImage.onload = () => {
          this.querySelectorAll('[data-bunny-url]').forEach((container) => {
            if (container.dataset.bunnyUrl !== bunnyUrl) return;

            container.querySelectorAll('[data-bunny-thumbnail]').forEach((image) => {
              image.src = safeThumbnailUrl;
              image.hidden = false;
            });

            container.querySelectorAll('[data-bunny-thumbnail-fallback]').forEach((fallback) => {
              fallback.hidden = true;
            });
          });
        };

        preloadImage.src = safeThumbnailUrl;
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');

        if (!this.stickyHeader) return;

        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer?.slider) return;

        this.elements.viewer.slider.setAttribute('role', 'presentation');

        this.elements.viewer.sliderItems.forEach((slide) => {
          slide.setAttribute('role', 'presentation');
        });
      }
    }
  );
}
/* ==========================================================
   GEMKRISHNA - BUNNY ACTIVE VIDEO AUTOPLAY
   Keeps preload=false for cost efficiency.
   Only the ACTIVE Bunny video is played.
   ========================================================== */

(() => {
  const MediaGallery = customElements.get('media-gallery');

  if (!MediaGallery) return;
  if (MediaGallery.prototype.__gkBunnyAutoplayPatched) return;

  MediaGallery.prototype.__gkBunnyAutoplayPatched = true;

  const originalPlayActiveMedia =
    MediaGallery.prototype.playActiveMedia;

  const bunnyPlayers = new WeakMap();


  /* -----------------------------------------
     Load Bunny Player.js only when required
     ----------------------------------------- */

  function loadBunnyPlayerJs() {
    if (window.playerjs?.Player) {
      return Promise.resolve();
    }

    if (window.gkBunnyPlayerJsPromise) {
      return window.gkBunnyPlayerJsPromise;
    }

    window.gkBunnyPlayerJsPromise = new Promise(
      (resolve, reject) => {

        const existingScript =
          document.querySelector(
            'script[data-gk-bunny-playerjs]'
          );

        if (existingScript) {
          existingScript.addEventListener(
            'load',
            resolve,
            { once: true }
          );

          existingScript.addEventListener(
            'error',
            reject,
            { once: true }
          );

          return;
        }

        const script =
          document.createElement('script');

        script.src =
          'https://assets.mediadelivery.net/playerjs/playerjs-latest.min.js';

        script.async = true;

        script.setAttribute(
          'data-gk-bunny-playerjs',
          ''
        );

        script.onload = resolve;
        script.onerror = reject;

        document.head.appendChild(script);
      }
    );

    return window.gkBunnyPlayerJsPromise;
  }


  /* -----------------------------------------
     Get/create Bunny player
     ----------------------------------------- */

  function getBunnyPlayer(iframe) {
    let state = bunnyPlayers.get(iframe);

    if (state) {
      return state;
    }

    const player =
      new window.playerjs.Player(iframe);

    let resolveReady;

    const readyPromise =
      new Promise((resolve) => {
        resolveReady = resolve;
      });

    state = {
      player,
      ready: false,
      readyPromise
    };

    player.on('ready', () => {
      state.ready = true;
      resolveReady();
    });

    bunnyPlayers.set(iframe, state);

    return state;
  }


  /* -----------------------------------------
     Pause Bunny players in this gallery
     ----------------------------------------- */

  async function pauseOtherBunnyVideos(
    gallery,
    exceptIframe = null
  ) {
    try {
      await loadBunnyPlayerJs();
    } catch (_error) {
      return;
    }

    const iframes =
      gallery.querySelectorAll(
        '.gk-bunny-video-iframe'
      );

    iframes.forEach((iframe) => {

      if (iframe === exceptIframe) return;

      const state =
        bunnyPlayers.get(iframe);

      if (!state || !state.ready) return;

      try {
        state.player.pause();
      } catch (_error) {
        /* Ignore harmless player timing errors */
      }
    });
  }


  /* -----------------------------------------
     Override media playback behaviour
     ----------------------------------------- */

  MediaGallery.prototype.playActiveMedia =
    function (activeItem) {

      if (!activeItem) return;


      /* ==============================
         NORMAL SHOPIFY MEDIA
         ============================== */

      if (
        activeItem.dataset.bunnyMedia !== 'true'
      ) {

        pauseOtherBunnyVideos(this);

        return originalPlayActiveMedia.call(
          this,
          activeItem
        );
      }


      /* ==============================
         BUNNY VIDEO
         ============================== */

      this.activeMedia = activeItem;

      /* Pause normal Shopify video/media */
      if (window.pauseAllMedia) {
        window.pauseAllMedia();
      }

      const iframe =
        activeItem.querySelector(
          '.gk-bunny-video-iframe'
        );

      if (!iframe) return;


      loadBunnyPlayerJs()
        .then(async () => {

          if (!this.isConnected) return;

          const state =
            getBunnyPlayer(iframe);

          /*
           * Wait until Bunny player can
           * receive playback commands.
           */
          await state.readyPromise;

          /*
           * User may have switched media
           * while Bunny was becoming ready.
           */
          if (
            !this.isConnected ||
            this.activeMedia !== activeItem
          ) {
            return;
          }


          /* Pause every other Bunny video */
          await pauseOtherBunnyVideos(
            this,
            iframe
          );


          /*
           * MUTED AUTOPLAY
           *
           * Muting first is important because
           * browsers commonly block autoplay
           * with sound.
           */
          try {
            state.player.mute();
          } catch (_error) {
            /* Continue to play attempt */
          }

          try {
            state.player.play();
          } catch (_error) {
            /* Native Bunny controls remain usable */
          }
        })
        .catch(() => {
          /*
           * If Player.js cannot load,
           * leave Bunny's native player intact.
           */
        });
    };


  /* -----------------------------------------
     Autoplay if FIRST media is Bunny
     ----------------------------------------- */

  function playInitialBunnyMedia() {

    document
      .querySelectorAll('media-gallery')
      .forEach((gallery) => {

        const activeMedia =
          gallery.activeMedia ||
          gallery.querySelector(
            '.product__media-item.is-active'
          );

        if (
          activeMedia?.dataset.bunnyMedia ===
          'true'
        ) {
          gallery.playActiveMedia(
            activeMedia
          );
        }
      });
  }


  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        requestAnimationFrame(
          playInitialBunnyMedia
        );
      },
      { once: true }
    );
  } else {
    requestAnimationFrame(
      playInitialBunnyMedia
    );
  }
})();
/* ==========================================================
   GEMKRISHNA - RELIABLE BUNNY AUTOPLAY
   Plays Bunny only when the video is actually visible.
   ========================================================== */

(() => {
  if (window.__gkBunnyAutoplayInstalled) return;
  window.__gkBunnyAutoplayInstalled = true;

  /* -------------------------------------------------------
     1. Load Bunny's official Player.js
     ------------------------------------------------------- */
  function loadBunnyPlayerJS() {
    if (window.playerjs && window.playerjs.Player) {
      return Promise.resolve();
    }

    if (window.__gkBunnyPlayerPromise) {
      return window.__gkBunnyPlayerPromise;
    }

    window.__gkBunnyPlayerPromise = new Promise((resolve, reject) => {
      let script = document.querySelector(
        'script[data-gk-bunny-playerjs]'
      );

      if (script) {
        script.addEventListener(
          'load',
          () => resolve(),
          { once: true }
        );

        script.addEventListener(
          'error',
          reject,
          { once: true }
        );

        return;
      }

      script = document.createElement('script');

      script.src =
        'https://assets.mediadelivery.net/playerjs/playerjs-latest.min.js';

      script.async = true;
      script.dataset.gkBunnyPlayerjs = 'true';

      script.onload = () => resolve();
      script.onerror = reject;

      document.head.appendChild(script);
    });

    return window.__gkBunnyPlayerPromise;
  }


  /* -------------------------------------------------------
     2. Stop the previous iframe-reload method from
        interfering with Bunny.
     ------------------------------------------------------- */
  function disableBunnyReloadMethod() {
    const MediaGallery = customElements.get('media-gallery');

    if (!MediaGallery) return;

    if (
      MediaGallery.prototype
        .__gkBunnyReloadDisabled
    ) {
      return;
    }

    MediaGallery.prototype.__gkBunnyReloadDisabled = true;

    const existingPlayActiveMedia =
      MediaGallery.prototype.playActiveMedia;

    MediaGallery.prototype.playActiveMedia =
      function (activeItem) {
        if (!activeItem) return;

        /*
         * Bunny playback is now handled by
         * the visibility observer below.
         *
         * IMPORTANT:
         * Do NOT reload the iframe.
         */
        if (
          activeItem.dataset.bunnyMedia === 'true'
        ) {
          this.activeMedia = activeItem;

          if (window.pauseAllMedia) {
            window.pauseAllMedia();
          }

          return;
        }

        return existingPlayActiveMedia.call(
          this,
          activeItem
        );
      };
  }


  /* -------------------------------------------------------
     3. Initialise one product gallery
     ------------------------------------------------------- */
  function initBunnyGallery(gallery) {
    if (!gallery) return;

    if (gallery.dataset.gkBunnyAutoplayInit === 'true') {
      return;
    }

    const bunnySlides = Array.from(
      gallery.querySelectorAll(
        '.product__media-item[data-bunny-media="true"]'
      )
    );

    if (!bunnySlides.length) return;

    gallery.dataset.gkBunnyAutoplayInit = 'true';

    loadBunnyPlayerJS()
      .then(() => {
        const states = [];

        bunnySlides.forEach((slide) => {
          const iframe = slide.querySelector(
            '.gk-bunny-video-iframe'
          );

          if (!iframe) return;

          const player =
            new window.playerjs.Player(iframe);

          const state = {
            slide,
            iframe,
            player,
            ready: false,
            shouldPlay: false
          };

          states.push(state);


          /* Bunny player is ready for commands */
          player.on('ready', () => {
            state.ready = true;

            if (state.shouldPlay) {
              startPlayer(state);
            }
          });
        });


        /* ---------------------------------------------
           Pause every other Bunny video
           --------------------------------------------- */
        function pauseOthers(activeState) {
          states.forEach((state) => {
            if (state === activeState) return;
            if (!state.ready) return;

            try {
              state.player.pause();
            } catch (_) {}
          });
        }


        /* ---------------------------------------------
           Start Bunny muted
           --------------------------------------------- */
        function startPlayer(state) {
          if (!state.ready) {
            state.shouldPlay = true;
            return;
          }

          pauseOthers(state);

          try {
            state.player.mute();
          } catch (_) {}

          /*
           * Small delay lets slider/layout finish
           * before Bunny receives play command.
           */
          window.setTimeout(() => {
            if (!state.shouldPlay) return;

            try {
              state.player.play();
            } catch (_) {}
          }, 80);
        }


        /* ---------------------------------------------
           Pause Bunny when leaving slide
           --------------------------------------------- */
        function stopPlayer(state) {
          state.shouldPlay = false;

          if (!state.ready) return;

          try {
            state.player.pause();
          } catch (_) {}
        }


        /* ---------------------------------------------
           Watch actual VISIBILITY.

           This works for:
           - mobile swipe
           - desktop thumbnails
           - touch dragging
           - variant/gallery changes
           --------------------------------------------- */
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const state = states.find(
                (item) =>
                  item.slide === entry.target
              );

              if (!state) return;

              /*
               * Video must be reasonably visible.
               */
              if (
                entry.isIntersecting &&
                entry.intersectionRatio >= 0.45
              ) {
                state.shouldPlay = true;
                startPlayer(state);
              } else {
                stopPlayer(state);
              }
            });
          },
          {
            threshold: [
              0,
              0.25,
              0.45,
              0.7,
              1
            ]
          }
        );

        states.forEach((state) => {
          observer.observe(state.slide);
        });
      })
      .catch((error) => {
        console.error(
          'GemKrishna Bunny autoplay:',
          error
        );
      });
  }


  /* -------------------------------------------------------
     4. Initialise galleries
     ------------------------------------------------------- */
  function initAllBunnyGalleries() {
    disableBunnyReloadMethod();

    document
      .querySelectorAll('media-gallery')
      .forEach(initBunnyGallery);
  }


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAllBunnyGalleries,
      { once: true }
    );
  } else {
    initAllBunnyGalleries();
  }


  /* Shopify Theme Editor support */
  document.addEventListener(
    'shopify:section:load',
    () => {
      window.setTimeout(
        initAllBunnyGalleries,
        50
      );
    }
  );
})();